<template>
    <div ref="chart" class="chart-content"></div>
</template>

<script>
    import * as echarts from 'echarts';

    export default {
        name: "BarChart",
        props: {
            chartData: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        data() {
            return {
                chart: ''
            }
        },
        watch:{
            chartData:{
                handler(){
                    this.setOption();
                },
                deep: true
            }
        },
        mounted() {
            this.init();
            window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            handleResize() {
                this.chart.resize();
            },
            init() {
                this.chart = echarts.init(this.$refs.chart);
                this.setOption();
            },
            setOption() {
                this.chart.setOption({
                    color: ['#FF6A66'],
                    title: {
                        text: '收款金额(元)',
                        textStyle: {
                            color: '#ff4444',
                            fontSize: 16
                        },
                        top: 10
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        x: 40,
                        y: 56,
                        x2: 10,
                        y2: 40,
                        borderWidth: 1
                    },
                    xAxis: {
                        type: 'category',
                        data: Object.keys(this.chartData)
                    },
                    yAxis: [{
                        type: 'value'
                    }],
                    series: [{
                        type: 'bar',
                        barWidth: 16,
                        label: {
                            show: true,
                            color: 'red',
                            position: 'top'
                        },
                        data: Object.values(this.chartData),
                        itemStyle: {
                            barBorderRadius: [3, 3, 0, 0]
                        },
                    }]
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .chart-content {
        width: 100%;
        height: 100%;
        color: rgb(15, 159, 225);
    }
</style>

